/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */

export const generateMagazineHeaderSettings = () => {
  let rowSettings = [
    { label: "Background Color", type: "colorPicker", keyName: "theme" },
    {
      label: "Subscribe Button",
      type: "checkbox",
      keyName: "showButton"
    },
    {
      label: "Button Text",
      type: "text",
      keyName: "buttonText"
    }
  ];
  return { settings: rowSettings };
};

export const generateMagazineEditionsSettings = () => {
  let rowSettings = [
    {
      type: "radioButton",
      label: "Feature Issues",
      keyName: "sortBy",
      radioOptions: [
        {
          name: "Relatively Older Issues",
          value: "older-issues"
        },
        {
          name: "Latest Issues",
          value: "latest-issues"
        }
      ]
    },
    { label: "Show Row Title", type: "checkbox", keyName: "showRowTitle" },
    { label: "Row title", type: "text", keyName: "rowTitle" },
    { label: "Background Color", type: "colorPicker", keyName: "theme" },
    {
      label: "Issue Title",
      type: "dropDown",
      keyName: "editionNameFormat",
      dropDownOptions: [{ label: "Issue Date", value: "magazineDate" }, { label: "Issue Name", value: "magazineTitle" }]
    }
  ];
  return { settings: rowSettings };
};

export const generateMagazineWidgetSettings = () => {
  const showHideSettings = [
    {
      label: "Row Title",
      type: "checkbox",
      keyName: "showRowTitle"
    },
    {
      label: "Author Name",
      type: "checkbox",
      keyName: "showAuthor"
    },
    {
      label: "Publish Time",
      type: "checkbox",
      keyName: "showTime"
    },
    {
      label: "Time to read",
      type: "checkbox",
      keyName: "showReadTime"
    }
  ];
  const styleSettings = [
    { label: "Theme", type: "colorPicker", keyName: "theme" },
    {
      label: "Border",
      type: "dropDown",
      keyName: "border",
      dropDownOptions: [{ label: "Default", value: "" }, { label: "With Border", value: "borderBottom" }]
    }
  ];

  const showHideButtonSettings = [
    {
      label: "Enable Button",
      type: "checkbox",
      keyName: "showButton"
    }
  ];

  const buttonSettings = [
    {
      label: "Button Text",
      type: "text",
      keyName: "buttonText",
      placeholder: "Read More"
    }
  ];

  return { showHideSettings, styleSettings, buttonSettings, showHideButtonSettings };
};
